<template>
	<div class="login" id="app" @keyup.enter="submitForm('ruleForm')">
		<!-- 导航返回首页 -->
		<div class="logo" @click="homeIndex" style="position: absolute;top:40px;left:40px"><img src="../../assets/logo.png" style="width: 80px;height: 80px;cursor: pointer;" /></div>
		<!-- 导航返回首页 -->
		<div class="login-container text-center">
			<h2>用户登录</h2>
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-position="top" class="demo-ruleForm text-left" style="max-width: 500px;margin:30px auto;">
				<el-form-item label="手机号" prop="mobile"><el-input type="text" v-model="ruleForm.mobile" autocomplete="off" placeholder="请输入账号"></el-input></el-form-item>
				<el-form-item label="登录密码" prop="password">
					<el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item class="flex space-between">
					<el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
					<el-button @click="register">注册</el-button>
				</el-form-item>
			</el-form>
			<el-divider>第三方登录</el-divider>
			<div class="else-login flex" style="justify-content: space-around;">
				<div class="weixin-login" @click="elseLogin('weixin')">
					<img src="../../assets/weixin.png" style="width: 40px;height: 40px;" />
					<div>微信登录</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" width="30%" class="puzz">
			<div class="puzzle-box">
				<puzzle-verification
					:onSuccess="handleSuccess"
					:puzzleImgList="puzzleImgList"
					:isVerificationShow="isVerificationShow"
					ref="PuzzleVerification"
					:width="screenWidth <= '768' ? screenWidth * 0.8 - 70 : '260'"
				/>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import PuzzleVerification from '../../plugins/verify.js';
export default {
	components: {
		PuzzleVerification
	},
	data() {
		var checkUser = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('账号不能为空'));
			} else {
				callback();
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		return {
			screenWidth: document.body.clientWidth,
			ruleForm: {
				mobile: '',
				password: ''
				// verify: ''
			},
			rules: {
				password: [
					{
						validator: validatePass,
						trigger: 'blur'
					}
				],
				mobile: [
					{
						validator: checkUser,
						trigger: 'blur'
					}
				]
			},
			isVerificationShow: true,
			puzzleImgList: [
				require('../../assets/verifyImages/verify1.png'),
				require('../../assets/verifyImages/verify2.png'),
				require('../../assets/verifyImages/verify3.png'),
				require('../../assets/verifyImages/verify4.png'),
				require('../../assets/verifyImages/verify5.png'),
				require('../../assets/verifyImages/verify6.png'),
				require('../../assets/verifyImages/verify7.png'),
				require('../../assets/verifyImages/verify8.png')
			],
			dialogVisible: false
		};
	},
	computed: {
		appName() {
			return this.$store.state.auth.appName;
		}
	},
	mounted() {
		this.$axios({
			url: this.HOST + '/admin.login/settingInfo',
			method: 'post'
		})
			.then(res => {
				this.setAppName(res.data.systemName);
			})
			.catch(err => {});
	},
	methods: {
		...mapActions({
			login: 'auth/login'
		}),
		...mapMutations({
			setAppName: 'auth/setAppName'
		}),
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.dialogVisible = true;
					this.isVerificationShow = false;
					setTimeout(() => {
						this.isVerificationShow = true;
					}, 100);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		register() {},
		reflesh() {
			this.$refs.PuzzleVerification.refreshImg();
		},
		onClose(e) {
			console.log(e);
		},
		handleSuccess() {
			this.dialogVisible = false;
			this.isVerificationShow = false;
			let url = this.HOST + '/home.login/login';
			let userInfo = this.ruleForm;
			this.login({
				url,
				userInfo
			}).then(res => {
				if (res.data.status == 1) {
					this.$router.history.go(-1);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		elseLogin() {}
	}
};
</script>

<style lang="scss">
#app {
	overflow: hidden;
}
.login {
	position: relative;
	.login-container {
		position: absolute;
		width: 400px;
		height: 500px;
		padding: 20px;
		background-color: #fff;
		top: 150px;
		right: 200px;
		border-radius: 50px;
		color: #343434;
		h2 {
			color: #343434;
		}
		.el-form-item__label {
			line-height: 25px;
		}
	}
}
.puzzle-box {
	box-sizing: border-box;
}
.puzzle-container {
	box-sizing: border-box;
	width: 100%;
}

@media screen and (max-width: 768px) {
	#puzzle-box,
	.slider-container {
		width: 100% !important;
	}
	.el-dialog {
		width: 80% !important;
	}
}
.puzzle-container {
	display: block !important;
}
.puzzle-container > div {
	margin-left: auto;
	margin-right: auto;
}
.else-login {
	font-size: 14px;
}
</style>
